import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import {Route} from 'vue-router';

export interface ITagView extends Partial<Route> {
  title?: string;
}

export interface ITagsViewState {
  visitedViews: ITagView[];
  cachedViews: Array<string | undefined>;
}
@Module({ dynamic: true, store, name: 'tagsView' })
class TagsView extends VuexModule implements ITagsViewState {
  public visitedViews: ITagView[] = [];
  public cachedViews: Array<string | undefined> = [];

  @Action
  public AddView(view: ITagView) {
    this.ADD_VISITED_VIEW(view);
    this.ADD_CACHED_VIEW(view);
  }
  @Action
  public AddVisitedView(view: ITagView) {
    this.ADD_VISITED_VIEW(view);
  }
  @Action
  public DelView(view: ITagView) {
    this.DEL_VISITED_VIEW(view);
    this.DEL_CACHED_VIEW(view);
  }
  @Action
  public DelViewByPath(path: string) {
    const view = this.visitedViews.find((tagView) => tagView.path === path);
    if (view) {
      this.DelView(view);
    }
  }
  @Action
  public ChangeView(view: ITagView) {
    const index = this.visitedViews.findIndex((viewItem) => viewItem.path === view.path);
    if (index > -1) {
      this.visitedViews[index] = view;
    }
  }
  @Action
  public DelCachedView(view: ITagView) {
    this.DEL_CACHED_VIEW(view);
  }
  @Action
  public DelOthersViews(view: ITagView) {
    this.DEL_OTHERS_VISITED_VIEWS(view);
    this.DEL_OTHERS_CACHED_VIEWS(view);
  }
  @Action
  public DelAllViews() {
    this.DEL_ALL_VISITED_VIEWS();
    this.DEL_ALL_CACHED_VIEWS();
  }
  @Mutation
  private ADD_VISITED_VIEW(view: ITagView) {
    const index = this.visitedViews.findIndex((viewItem) => viewItem.path === view.path);
    if (index > -1) {
      this.visitedViews[index] = view;
      return;
    }
    this.visitedViews.push(
      Object.assign({}, view, {
        title: view.meta?.title || 'no-name',
      }),
    );
  }
  @Mutation
  private ADD_CACHED_VIEW(view: ITagView) {
    if (view.name === null) {
      return;
    }
    if (this.cachedViews.includes(view.name)) {
      return;
    }
    if (!view.meta?.noCache) {
      this.cachedViews.push(view.name);
    }
  }
  @Mutation
  private DEL_VISITED_VIEW(view: ITagView) {
    for (const [index, viewVal] of this.visitedViews.entries()) {
      if (viewVal.path === view.path) {
        this.visitedViews.splice(index, 1);
        break;
      }
    }
  }
  @Mutation
  private DEL_CACHED_VIEW(view: ITagView) {
    if (view.name === null) {
      return;
    }
    const index = this.cachedViews.indexOf(view.name);
    if (index > -1) {
      this.cachedViews.splice(index, 1);
    }
  }
  @Mutation
  private DEL_OTHERS_VISITED_VIEWS(view: ITagView) {
    this.visitedViews = this.visitedViews.filter((viewItem) => {
      return viewItem.meta?.affix || viewItem.path === view.path;
    });
  }
  @Mutation
  private DEL_OTHERS_CACHED_VIEWS(view: ITagView) {
    if (view.name === null) {
      return;
    }
    const index = this.cachedViews.indexOf(view.name);
    if (index > -1) {
      this.cachedViews = this.cachedViews.slice(index, index + 1);
    } else {
      this.cachedViews = [];
    }
  }
  @Mutation
  private DEL_ALL_VISITED_VIEWS() {
    const affixTags = this.visitedViews.filter((tag) => tag.meta?.affix);
    this.visitedViews = affixTags;
  }
  @Mutation
  private DEL_ALL_CACHED_VIEWS() {
    this.cachedViews = [];
  }
}
export const TagsViewModule = getModule(TagsView);
